import { HourglassBottomOutlined, HourglassEmptyOutlined } from '@mui/icons-material';
import type { ProcessingInsightDto, ProcessingStatus } from '@/types/dtos/media/processing-insight.dto';

type MediaItemProcessingSpinnerProps = {
  size?: number;
  /** When set, queued/pending/not_started → empty hourglass; active work → bottom hourglass. */
  status?: ProcessingStatus | ProcessingInsightDto['status'];
};

/** Waiting in queue (not yet actively processed). */
export function isQueuedProcessingStatus(status?: ProcessingStatus): boolean {
  return status === 'queued' || status === 'pending' || status === 'not_started' || status === undefined;
}

export function MediaItemProcessingSpinner({ size = 20, status }: MediaItemProcessingSpinnerProps) {
  const sx = { width: size, height: size } as const;

  if (isQueuedProcessingStatus(status)) {
    return <HourglassEmptyOutlined color="info" sx={sx} />;
  }

  return <HourglassBottomOutlined color="info" sx={sx} />;
}
